<template>
    <Dialog v-model:visible="internalValue" modal closable class="check-if-horse-exist-dialog"
            :header="$t('message.existHorse.horseExist')">
        <div class="p-3">
            <div class="mb-3" v-if="disclaimer">
                {{disclaimer}}
            </div>
            <div class="mb-3" v-else-if="externalHorse">
                    The list below contains similar horses already in the system. If you want to update an existing horse instead of creating a new one, click the plus button.
            </div>
            <div class="mb-3" v-else-if="pedigree">
                The list below contains similar horses already in the system. If you want to use an existing horse instead of creating a new one, click the plus button.
            </div>
            <DataTable :value="similarHorses" lazy dataKey="id">
                <Column field="name" :header="$t('message.existHorse.name')"></Column>
                <Column field="birthCountry" :header="$t('message.existHorse.countryOfBirth')"></Column>
                <Column field="dateOfBirth" :header="$t('message.existHorse.dateOfBirth')"></Column>
                <Column field="color" :header="$t('message.existHorse.color')"></Column>
                <Column field="ueln" :header="$t('message.existHorse.ueln')"></Column>
                <Column field="sex" :header="$t('message.existHorse.sex')"></Column>
                <Column :header="$t('message.existHorse.details')" class="w-1 text-center">
                    <template #body="{ data }">
                        <a :href="getEditHorseUrl(data)" target="_blank" rel="noopener"
                           class="flex justify-content-center align-items-center">
                            <i class="pi pi-arrow-right" />
                        </a>
                    </template>
                </Column>
                <Column v-if="pedigree" :header="$t('message.existHorse.useHorse')" class="w-1 text-center">
                    <template #body="{ data }">
                        <div class="flex justify-content-center align-items-center">
                            <CustomIconButton v-if="checkSexCondition(data.sex)" icon="pi pi-plus" onlyIcon @click="useHorse(data)" />
                        </div>
                    </template>
                </Column>
                <Column v-if="externalHorse" :header="$t('message.existHorse.useHorse')" class="w-1 text-center">
                    <template #body="{ data }">
                        <div v-if="data.horseStatus === 'EXTERNAL'" class="flex justify-content-center align-items-center">
                            <CustomIconButton icon="pi pi-plus" onlyIcon @click="useHorse(data)" />
                        </div>
                    </template>
                </Column>
            </DataTable>
        </div>
    </Dialog>
</template>

<script>
    import Dialog from 'primevue/dialog';
    import DataTable from "primevue/datatable";
    import Column from "primevue/column";
    import CustomIconButton from "./form/CustomIconButton.vue";
    import {HorseUtils} from "@/utils/HorseUtils";

    export default {
        name: "CheckIfHorseExistDialog",

        components: {
            Dialog,
            DataTable,
            Column,
            CustomIconButton,
        },

        props: {
            modelValue: null,
            similarHorses: null,
            pedigree: {
                type: Boolean,
                default: false,
            },
            disclaimer: {
                type: String,
                default: null,
            },
            externalHorse: {
                type: Boolean,
                default: false,
            },
            horseSex: null
        },

        emits: ["update:modelValue", "useHorse"],

        data() {
            return {};
        },

        methods: {
            useHorse(value) {
                this.$emit("useHorse", value);
            },
            getEditHorseUrl(horse) {
                return HorseUtils.getHorseEditUrl(horse.horseStatus, horse.id);
            },
            checkSexCondition(sex) {
                const sexMappings = {
                    STALLION: ["STALLION", "MALE", "MONORCHID"],
                    BROODMARE: ["BROODMARE", "FEMALE"]
                };

                const validSexes = sexMappings[this.horseSex];
                return validSexes ? validSexes.includes(sex) : false;
            }
        },

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            }
        },
    };
</script>

<style lang="scss">
</style>
